import { createAction } from 'redux-act';

export const setNetLoungeSucces = createAction<any>('Lounge Success');
export const setLoungeEmpty = createAction<any>('Lounge Success');
